import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class IsWatchedHelper extends Helper {
  @service watchlist;

  compute([eventUuid, entryUuid]) {
    return this.watchlist.isWatched(eventUuid, entryUuid);
  }
}
